export const BASE_URL = process.env.NODE_ENV === 'production' ? 'https://zamon.al-electronics.uz' : 'http://192.168.0.39:8001'
const API_V1 = "/api/v1";
import { i18n } from "../../i18n";

export async function getEmployees(cb, pageSize, offset) {
  fetch(
    `${BASE_URL}/${i18n.global.locale.value
    }${API_V1}/user/employees?limit=${pageSize}&offset=${offset * pageSize}`
  )
    .then(res => {
      return res.json();
    })
    .then(json => {
      cb(json["results"], json["count"]);
    });
}

export async function getJournalists(cb, pageSize, offset) {
  fetch(
    `${BASE_URL}/${i18n.global.locale.value
    }${API_V1}/user/journalists?limit=${pageSize}&offset=${offset * pageSize}`
  )
    .then(res => {
      return res.json();
    })
    .then(json => {
      cb(json["results"], json["count"]);
    });
}

export async function signUp(cb, formPayload, err) {
  fetch(`${BASE_URL}/${i18n.global.locale.value}${API_V1}/user/app-acc`, {
    method: 'POST',
    body: formPayload,
  })
    .catch((e) => {
      err(e)
    })
    .then(() => {
      cb()
    });
}

export async function getMe(cb, token, err) {
  fetch(`${BASE_URL}/${i18n.global.locale.value}${API_V1}/user/get-me`, {
    // mode: '*cors', // no-cors, *cors, same-origin
    headers: {
      'Authorization': `Bearer ${token}`
    },
  })
    .catch((e) => {
      err(e)
      console.log(e)
    })
    .then((res) => {
      if (!res.ok) err(res)
      return res.json()
    })
    .then((res) => {
      cb(res)
    });
}

export async function getStaffNews(cb, token, status, offset, pageSize) {
  fetch(`${BASE_URL}/${i18n.global.locale.value}${API_V1}/user/news?status=${status}&limit=${pageSize}&offset=${offset * pageSize}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((json) => {
      cb(json["results"], json['count'])
    });
}

export async function updateUser(cb, token, newData, err) {
  fetch(`${BASE_URL}/en${API_V1}/user/crud`, {
    method: 'PATCH',
    body: newData,
    headers: {
      'Authorization': `Bearer ${token}`
    },
  })
    .catch((e) => {
      err(e)
    })
    .then(async (res) => {
      if (!res.ok) return err(await res.json())
      return cb(await res.json())
    })
}

export async function userPassword(cb, token, newData, err) {
  fetch(`${BASE_URL}/auth/users/set_password/`, {
    method: 'POST',
    body: newData,
    headers: {
      'Authorization': `Bearer ${token}`
    },
  })
    .catch((e) => {
      err(e)
    })
    .then(async (res) => {
      if (!res.ok) return err(await res.json())
      return cb()
    })
}


export async function unique(cb, newData, err) {
  fetch(`${BASE_URL}/${i18n.global.locale.value}${API_V1}/user/checker`, {
    method: 'POST',
    body: newData,
  })
    .catch(e => {
      err(e);
    })
    .then(async res => {
      // console.log(res);
      if (!res.ok) throw err(res);
      return await cb(res);
    });
}

export async function setMail(cb, newData, err) {
  fetch(`${BASE_URL}/${i18n.global.locale.value}${API_V1}/user/request-reset-email`, {
    method: 'POST',
    body: newData,
  })
    .catch(e => {
      err(e);
    })
    .then(async res => {
      if (!res.ok) throw err(res);
      return await cb(res);
    });
}

export async function resetPwd(cb, newData, err) {
  fetch(`${BASE_URL}/${i18n.global.locale.value}${API_V1}/user/request-reset-complete`, {
    method: 'PATCH',
    body: newData,
  })
    .catch(e => {
      err(e);
    })
    .then(async res => {
      if (!res.ok) throw err(res);
      return await cb(res);
    });
}

export async function getAuthors(cb) {
  fetch(`${BASE_URL}/en${API_V1}/user/author-list`)
    .then(res => {
      return res.json();
    })
    .then(json => {
      cb(json);
    });
}
